// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"fb1e50ae","307":"f279e75b"}[chunkId] + ".chunk.css";
};